module.exports = __webpack_public_path__ + "static/media/mgrIcon2.a807bd5e.svg";